import React from "react"
import PropTypes from "prop-types"
import { Button } from "datastory-shared/ui"
import { Slider } from "datastory-shared/data-ui"
import { format as formatDate } from "datastory-shared/utils/date"

import chart from "./parliament-chart"

class HypoRiksdagChart extends React.Component {
  static propTypes = {
    data: PropTypes.object,
    withSlider: PropTypes.bool,
    sliderProps: PropTypes.object,
  }

  static defaultProps = {
    withSlider: false,
    sliderProps: {},
  }

  state = {
    date: null,
    dates: [],
  }

  static getDerivedStateFromProps(props, state) {
    if (!props.data) return null
    const dates = Object.keys(props.data).sort((a, b) => +a - +b)

    return {
      date: props.data[state.date] ? state.date : dates[dates.length - 1],
      dates,
    }
  }

  componentDidMount() {
    if (this.props.data) {
      this.chart = chart()
      this.chart.create(this.chartHolder, { ...this.props, ...this.state })
    }
  }

  componentDidUpdate() {
    if (this.props.data) {
      if (!this.chart) {
        this.chart = chart()
        this.chart.create(this.chartHolder, { ...this.props, ...this.state })
      }
      this.chart.update({ ...this.props, ...this.state })
    }
  }

  componentWillUnmount() {
    this.chart && this.chart.destroy()
  }

  sliderTooltipFormat = time => (
    <span style={{ whiteSpace: "nowrap", textTransform: "capitalize" }}>
      {formatDate(new Date(+time), { month: "short", year: "numeric" })}
    </span>
  )

  sliderTickFormat = time => {
    if (!this.holder) return null

    // ensure at least 200px for a tick
    const n = Math.floor(this.holder.offsetWidth / 200)
    const l = this.state.dates.length
    const c = Math.floor(l / n)
    const i = this.state.dates.findIndex(d => +d === time)

    return (i % c === 0 && i < l - 2) || i === l - 1 ? (
      <Button
        variant="ghost"
        size="sm"
        onClick={() => {
          this.setState({
            date: time,
          })
        }}
      >
        {formatDate(new Date(time), { month: "short", year: "numeric" })}
      </Button>
    ) : null
  }

  render() {
    const { data, withSlider, sliderProps } = this.props
    const { date, dates } = this.state

    return !data ? null : (
      <>
        <div
          style={{ position: "relative" }}
          data-cy="hypotheticalriksdag-chart"
          ref={holder => {
            this.holder = holder
          }}
        >
          <svg
            ref={chartHolder => {
              this.chartHolder = chartHolder
            }}
          />
        </div>
        {withSlider && date && dates.length && (
          <div
            style={{
              paddingTop: "3rem",
              paddingLeft: "1rem",
              paddingRight: "2rem",
            }}
            data-cy="hypotheticalriksdag-chart-slider"
          >
            <Slider
              value={+new Date(+date)}
              customDomain={dates.map(i => +new Date(+i))}
              tooltipFormat={this.sliderTooltipFormat}
              tickFormat={this.sliderTickFormat}
              onChange={time => {
                this.setState({
                  date: time,
                })
              }}
              interpolate={false}
              duration={1000}
              playMode
              tickValues="on"
              {...sliderProps}
            />
          </div>
        )}
      </>
    )
  }
}

export default HypoRiksdagChart
